import { FC, JSX, MouseEventHandler, ReactNode } from 'react'

import ClearIcon from '@mui/icons-material/Clear'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { CircularProgress, IconButton, InputAdornment, InputAdornmentProps } from '@mui/material'
import { SxProps, Theme } from '@mui/system'

import { AUTOCOMPLETE_TEST_IDS } from './Autocomplete.constants'

type AdormentProps = {
  isLoading?: boolean
  error?: unknown
  icon?: JSX.Element | null | ReactNode
  onClear?: MouseEventHandler<HTMLButtonElement>
  showClearIcon?: boolean
  closeSx?: SxProps<Theme>
  iconSx?: SxProps<Theme>
} & Partial<InputAdornmentProps>

export const EndInputAdornment: FC<AdormentProps> = ({
  isLoading,
  error,
  closeSx,
  icon,
  onClear,
  showClearIcon,
  iconSx,
  ...rest
}) => {
  return (
    <>
      {isLoading && <CircularProgress sx={{ mr: 3.75 }} size={20} />}
      {error && <ErrorOutlineIcon sx={{ mr: 3.75 }} color="error" fontSize="medium" />}
      {showClearIcon && (
        <InputAdornment position="end" sx={{ mr: -2.4, ...closeSx }}>
          <IconButton onClick={onClear} data-testid={AUTOCOMPLETE_TEST_IDS.clearButton}>
            <ClearIcon fontSize="medium" />
          </IconButton>
        </InputAdornment>
      )}
      <InputAdornment
        {...rest}
        position="end"
        sx={{ mr: showClearIcon ? 'auto' : -2.6, ...iconSx }}
      >
        {icon}
      </InputAdornment>
    </>
  )
}
